var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.announcement.enabled)?_c('v-alert',{attrs:{"icon":_vm.getIcon,"prominent":"","text":"","color":_vm.getType}},[_vm._v(" "+_vm._s(_vm.announcement.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }